<template>
	
	<!-- Layout Footer -->
	<a-layout-footer>
        <div>
            <!-- Floating Feedback Bubble -->
            <div class="feedback-bubble" @click="showModal">
                <MessageOutlined :style="{ fontSize: '24px' }" />
            </div>

            <!-- Feedback Modal -->
            <a-modal
                v-model:open="isModalVisible"
                title="Hãy để lại đánh giá để team cải thiện sản phẩm"
                :footer="null"
                @cancel="handleCancel"
                width="500px"
            >
                <div class="feedback-form">
                    <!-- Rating Buttons -->
                    <div class="rating-section">
                        <label class="rating-label">Đánh giá của bạn:</label>
                        <div class="rating-buttons">
                            <a-button
                                v-for="rating in ratings"
                                :key="rating.value"
                                :type="selectedRating === rating.value ? 'primary' : 'default'"
                                @click="selectedRating = rating.value"
                                class="rating-btn"
                            >
                                {{ rating.label }}
                            </a-button>
                        </div>
                    </div>

                    <!-- Feedback Text Input -->
                    <div class="feedback-input-section">
                        <label class="feedback-label">Phản hồi chi tiết:</label>
                        <a-textarea
                            v-model:value="feedbackText"
                            :rows="5"
                            placeholder="Nhập phản hồi của bạn tại đây..."
                            class="feedback-textarea"
                        />
                    </div>

                    <!-- Submit Button -->
                    <div class="submit-section">
                        <a-button type="primary" size="large" @click="handleSubmit" block>
                            Gửi phản hồi
                        </a-button>
                    </div>
                </div>
            </a-modal>
        </div>
	</a-layout-footer>
	<!-- / Layout Footer -->

</template>


<script setup>
import { ref } from 'vue';
import { MessageOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import {AssertionResponse, OptionalData} from "@/utils/types";
import TaskService from "@/services/task";
import {ElNotification} from "element-plus";

const isModalVisible = ref(false);
const selectedRating = ref(null);
const feedbackText = ref('');
const ratings = [
    { value: 1, label: '😣 Tồi' },
    { value: 2, label: '😕 Tạm' },
    { value: 3, label: '😬 Ổn' },
    { value: 4, label: '🙂 Tốt' },
    { value: 5, label: '🤩 Tuyệt' }
];

const showModal = () => {
    isModalVisible.value = true;
};

const handleCancel = () => {
    isModalVisible.value = false;
};

const handleSubmit = () => {
    if (!selectedRating.value) {
        message.warning('Vui lòng chọn đánh giá!');
        return;
    }

    if (!feedbackText.value.trim()) {
        message.warning('Vui lòng nhập phản hồi!');
        return;
    }

    submitFeedback();

    // Show success message
    message.success('Cảm ơn phản hồi của bạn!');

    // Close modal and clear form
    isModalVisible.value = false;
    clearForm();
};

const submitFeedback = async () => {
    // This function can be customized to send data to your backend
    console.log('Feedback submitted:', {
        rating: selectedRating.value,
        ratingLabel: ratings.find(r => r.value === selectedRating.value)?.label,
        feedback: feedbackText.value
    });
    try {
        const payload = {
            task_id: "",
            feedback_score: (selectedRating.value).toString(),
            feedback_text: feedbackText.value,
        };
        const res = await TaskService.sendFeedback(payload);
        if (res.status) {
            ElNotification({
                title: "Thành công",
                message: res.statusText,
                type: "success",
            });
        } else {
            ElNotification({
                title: "Thất bại",
                message: res.statusText,
                type: "error",
            });
        }
    } catch (error) {
        console.log(error);
    }
};

const clearForm = () => {
    selectedRating.value = null;
    feedbackText.value = '';
};
</script>

<style scoped>
.feedback-bubble {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    z-index: 1000;
}

.feedback-bubble:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.feedback-form {
    padding: 10px 0;
}

.rating-section {
    margin-bottom: 24px;
}

.rating-label,
.feedback-label {
    display: block;
    margin-bottom: 12px;
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.rating-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.rating-btn {
    flex: 1;
    min-width: 70px;
    height: 40px;
    font-weight: 500;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.rating-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.feedback-input-section {
    margin-bottom: 24px;
}

.feedback-textarea {
    border-radius: 6px;
    resize: none;
}

.submit-section {
    margin-top: 20px;
}
</style>